import fetchProductRecData from '@/components/ProductRecommendations/filter-item-recommendations-fetch-data.js'

export default {
  namespaced: true,
  state: {
    miniCartItems: [],
    miniCartSkus: [],
    miniCartRecIsLoading: false,
    initialisedByDy: false,
  },

  mutations: {
    setMiniCartItems(state, payload) {
      state.miniCartItems = payload
    },
    setMiniCartSkus(state, payload) {
      state.miniCartSkus = payload
    },
    setMiniCartRecIsLoading(state, payload) {
      state.miniCartRecIsLoading = payload
    },
    setInitialisedByDy(state, payload) {
      state.initialisedByDy = payload
    },
  },

  actions: {
    fetchData({ state, commit }, payload) {
      const args = state.miniCartSkus.length
        ? { skus: state.miniCartSkus }
        : { excludeProductId: payload ? payload.excludeProductId : '' }

      fetchProductRecData(args).then(items => {
        commit('setMiniCartItems', items)
        commit('setMiniCartRecIsLoading', false)
        DY.recommendationContext = On.DynamicYield.pageContext
      })
    },
    setMiniCartSkusByDy({ commit }, payload) {
      if (!On.DynamicYield.shouldUpdateRecommendation) return

      commit('setInitialisedByDy', true)
      commit('setMiniCartSkus', payload)
    },
  },

  getters: {
    miniCartItems: state => state.miniCartItems,
    miniCartSkus: state => state.miniCartSkus,
    miniCartRecIsLoading: state => state.miniCartRecIsLoading,
    initialisedByDy: state => state.initialisedByDy,
  },
}
